import { isRouteErrorResponse, useRouteError } from "@remix-run/react";

export function ErrorComponent() {
  const error = useRouteError();
  const isRouteError = isRouteErrorResponse(error);

  const title = isRouteError ? error.statusText : "Unknown Error";
  let description = "An unknown error occurred.";

  if (isRouteError) {
    switch (error.status) {
      case 404:
        description = "Sorry, we couldn't find the page you're looking for.";
        break;
      case 401:
        description = "You are not authorized to view this page.";
        break;
      case 403:
        description = "You are not authorized to view this page.";
        break;
      case 500:
        description = "An error occurred on the server.";
        break;
      default:
        description = "An unknown error occurred.";
        break;
    }
  }
  return (
    <div className="mt-12 p-8">
      {isRouteError ? <p className="mb-2 text-base font-semibold text-destructive">{error.status}</p> : null}
      <h1 className="text-3xl font-bold tracking-tight sm:text-5xl">{title}</h1>
      <p className="mt-2 text-base leading-7 text-muted-foreground">{description}</p>
    </div>
  );
}
